import { XStack, YStack, View, Text } from "tamagui";
import { RiArrowRightSLine } from "react-icons/ri";
import { colors } from "@styles/colors";
import { useSkinV2Page, v2 } from "@screen/Home/pages/GasShop/skin";

interface FnRowProps {
  icon: React.ReactNode;
  iconColor: string;
  label: string;
  sub?: string;
  right?: string;
  danger?: boolean;
  isLast?: boolean;
  onPress?: () => void;
}

/** icon + 標題 + 右側值 + 箭頭，用於管理功能列表 */
export default function FnRow({ icon, iconColor, label, sub, right, danger, isLast, onPress }: FnRowProps) {
  // V2：分隔線與其他白卡一致（v2.divider 比 borderLight 淡一階，卡片內才不會被切得一格一格）
  const skinV2 = useSkinV2Page();
  return (
    <XStack
      ai="center"
      gap="$3"
      px="$3.5"
      py="$3"
      bbw={isLast ? 0 : 1}
      bbc={skinV2 ? v2.divider : colors.borderLight}
      cursor="pointer"
      pressStyle={skinV2 ? { opacity: 0.7 } : undefined}
      onPress={onPress}>
      <View w={32} h={32} br={8} bg={`${iconColor}15`} ai="center" jc="center" flexShrink={0}>
        {icon}
      </View>
      <YStack f={1} miw={0}>
        <Text fontSize={14} fontWeight="600" color={danger ? colors.danger : colors.text}>
          {label}
        </Text>
        {sub && (
          <Text fontSize={11} color={colors.hint} mt="$0.5">
            {sub}
          </Text>
        )}
      </YStack>
      {right && (
        <Text fontSize={12} color={danger ? colors.danger : colors.sub} fontWeight={danger ? "700" : "600"} mr="$1">
          {right}
        </Text>
      )}
      <RiArrowRightSLine size={18} color={colors.hint} />
    </XStack>
  );
}
